// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Design-Tokens (hell = :root, dunkel = .dark auf <html>).
 * Formensprache "Instrument": Neutraltöne mit leichtem Blaugrün-Stich,
 * Teal als Markenfarbe, Signalorange nur für Warnungen/Beta.
 * Variablennamen bleiben kompatibel zu den bestehenden Komponenten.
 */
:root {
  /* Flächen */
  --bg-primary: #eef2f0;      /* Seitengrund */
  --bg-secondary: #f8faf9;    /* erhöhte Fläche (Formular, Produkt, Theme) */
  --bg-tertiary: #dfe7e4;     /* dezente Füllung, Hover */
  /* Text */
  --text-primary: #0f1b1e;
  --text-secondary: #46595d;
  --text-tertiary: #5f7276;
  /* Linien */
  --border-primary: #c5d0cd;
  --border-secondary: #a7b6b2;
  --shadow-primary: rgba(15, 27, 30, 0.08);
  --shadow-secondary: rgba(15, 27, 30, 0.04);
  /* Marke */
  --accent-primary: #0a7468;
  --accent-secondary: #0b5f73;
  --accent-hover: #075a51;
  --accent-soft: #d5ebe6;
  --on-accent: #ffffff;
  --brand-deep: #0b3b52;
  /* Signal & Status */
  --signal: #c2410c;
  --signal-soft: #fbe5d8;
  --success: #2f7d32;
  --warning: #b45309;
  --error: #b91c1c;
  /* Alt-Kompatibilität: Verläufe sind bewusst einfarbig */
  --gradient-primary: linear-gradient(var(--accent-primary), var(--accent-primary));
  --gradient-secondary: linear-gradient(var(--bg-secondary), var(--bg-secondary));

  /* Schrift */
  --font-display: 'Saira Condensed', 'Arial Narrow', 'Roboto Condensed', sans-serif;
  --font-body: 'Atkinson Hyperlegible', 'Segoe UI', system-ui, -apple-system, sans-serif;
  --font-mono: 'JetBrains Mono', ui-monospace, 'Cascadia Mono', Consolas, monospace;

  /* Form */
  --radius-sm: 3px;
  --radius: 4px;
  --tick: var(--accent-primary);
  --header-height: 64px;
  /* Themenfarben für Icons (gedeckt, passend zu den Neutraltönen) */
  --tone-accent: var(--accent-primary);
  --tone-sun: #c98a0b;
  --tone-water: #2f6fae;
  --tone-moon: #6458a8;
  --tone-health: #bf4a45;
  --tone-activity: #3a8a4c;
  --tone-terrain: #77762f;
  --tone-chart: #4a6fa5;
  --tone-air: #2b8a95;
  --tone-key: #b0631b;
  --tone-display: #8a4f9e;
  /* Kräftige Icon-Farben (Linien und Details); die Kacheln bleiben pastell (--tone-*) */
  --vivid-accent: #08806f;
  --vivid-sun: #d99a00;
  --vivid-water: #1d6fc4;
  --vivid-moon: #5a45c9;
  --vivid-health: #d6352d;
  --vivid-activity: #23913f;
  --vivid-terrain: #6d6b12;
  --vivid-chart: #34609f;
  --vivid-air: #0b97a6;
  --vivid-key: #c75f12;
  --vivid-display: #9a3db8;
  /* Abschnitts-Bänder der Produktseite */
  --band-a: #e6eeeb;
  --band-b: #e9ecf2;
  --band-buy: #fbf0e6;
  /* Neon für alles rund ums Kaufen */
  --neon-buy: #ff5f00;
  --neon-buy-glow: rgba(255, 95, 0, 0.45);
  --on-neon: #ffffff;
  --band-buy-border: #e3cfa8;
  --band-c: #eee9f1;
  --page-max: 86rem;

  color-scheme: light;
}

.dark {
  --bg-primary: #0a1214;
  --bg-secondary: #101b1e;
  --bg-tertiary: #18272b;
  --text-primary: #e3ebe9;
  --text-secondary: #a3b5b4;
  --text-tertiary: #84999a;
  --border-primary: #22363a;
  --border-secondary: #2f474c;
  --shadow-primary: rgba(0, 0, 0, 0.45);
  --shadow-secondary: rgba(0, 0, 0, 0.3);
  --accent-primary: #43c9b6;
  --accent-secondary: #5fb3d1;
  --accent-hover: #6bd8c8;
  --accent-soft: #12302d;
  --on-accent: #06211d;
  --brand-deep: #0b3b52;
  --signal: #ff8a3d;
  --signal-soft: #33200f;
  --success: #7bd389;
  --warning: #f5b84a;
  --error: #f87171;
  --tone-accent: var(--accent-primary);
  --tone-sun: #f2c14e;
  --tone-water: #6aa8e0;
  --tone-moon: #a99cf0;
  --tone-health: #ef8a84;
  --tone-activity: #7ccf8c;
  --tone-terrain: #c7c46e;
  --tone-chart: #8fb0e0;
  --tone-air: #6fd0da;
  --tone-key: #f0a35e;
  --tone-display: #d29be6;
  --vivid-accent: #4fd8c4;
  --vivid-sun: #ffcc33;
  --vivid-water: #5aaeff;
  --vivid-moon: #a594ff;
  --vivid-health: #ff7a70;
  --vivid-activity: #6ee08a;
  --vivid-terrain: #d6d26a;
  --vivid-chart: #8db8ff;
  --vivid-air: #4fe0ee;
  --vivid-key: #ffa45c;
  --vivid-display: #e290ff;
  --band-a: #0e191c;
  --band-b: #0f1720;
  --band-buy: #15110e;
  --neon-buy: #ff7a1a;
  --neon-buy-glow: rgba(255, 122, 26, 0.55);
  --on-neon: #1a0a00;
  --band-buy-border: #4a3d22;
  --band-c: #15121b;
  color-scheme: dark;
}

body {
  background-color: var(--bg-primary);
  color: var(--text-primary);
  transition: background-color 0.3s ease, color 0.3s ease;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: var(--bg-primary);
}

::-webkit-scrollbar-thumb {
  background: var(--border-secondary);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--text-tertiary);
}
`, "",{"version":3,"sources":["webpack://./src/styles/dark-mode.css"],"names":[],"mappings":"AAAA;;;;;EAKE;AACF;EACE,YAAY;EACZ,qBAAqB,OAAO,gBAAgB;EAC5C,uBAAuB,KAAK,8CAA8C;EAC1E,sBAAsB,MAAM,2BAA2B;EACvD,SAAS;EACT,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,WAAW;EACX,yBAAyB;EACzB,2BAA2B;EAC3B,wCAAwC;EACxC,0CAA0C;EAC1C,UAAU;EACV,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,wDAAwD;EACxD,iFAAiF;EACjF,+EAA+E;;EAE/E,YAAY;EACZ,iFAAiF;EACjF,sFAAsF;EACtF,iFAAiF;;EAEjF,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,qBAAqB;EACrB,kEAAkE;EAClE,oCAAoC;EACpC,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,sFAAsF;EACtF,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;EACpB,wBAAwB;EACxB,uCAAuC;EACvC,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;EACnC,mBAAmB;EACnB,uCAAuC;EACvC,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;EACjB,iBAAiB;;EAEjB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,2BAA2B;EAC3B,qCAAqC;EACrC,sCAAsC;EACtC,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;EACpB,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA,cAAc;AACd;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":["/*\n * Design-Tokens (hell = :root, dunkel = .dark auf <html>).\n * Formensprache \"Instrument\": Neutraltöne mit leichtem Blaugrün-Stich,\n * Teal als Markenfarbe, Signalorange nur für Warnungen/Beta.\n * Variablennamen bleiben kompatibel zu den bestehenden Komponenten.\n */\n:root {\n  /* Flächen */\n  --bg-primary: #eef2f0;      /* Seitengrund */\n  --bg-secondary: #f8faf9;    /* erhöhte Fläche (Formular, Produkt, Theme) */\n  --bg-tertiary: #dfe7e4;     /* dezente Füllung, Hover */\n  /* Text */\n  --text-primary: #0f1b1e;\n  --text-secondary: #46595d;\n  --text-tertiary: #5f7276;\n  /* Linien */\n  --border-primary: #c5d0cd;\n  --border-secondary: #a7b6b2;\n  --shadow-primary: rgba(15, 27, 30, 0.08);\n  --shadow-secondary: rgba(15, 27, 30, 0.04);\n  /* Marke */\n  --accent-primary: #0a7468;\n  --accent-secondary: #0b5f73;\n  --accent-hover: #075a51;\n  --accent-soft: #d5ebe6;\n  --on-accent: #ffffff;\n  --brand-deep: #0b3b52;\n  /* Signal & Status */\n  --signal: #c2410c;\n  --signal-soft: #fbe5d8;\n  --success: #2f7d32;\n  --warning: #b45309;\n  --error: #b91c1c;\n  /* Alt-Kompatibilität: Verläufe sind bewusst einfarbig */\n  --gradient-primary: linear-gradient(var(--accent-primary), var(--accent-primary));\n  --gradient-secondary: linear-gradient(var(--bg-secondary), var(--bg-secondary));\n\n  /* Schrift */\n  --font-display: 'Saira Condensed', 'Arial Narrow', 'Roboto Condensed', sans-serif;\n  --font-body: 'Atkinson Hyperlegible', 'Segoe UI', system-ui, -apple-system, sans-serif;\n  --font-mono: 'JetBrains Mono', ui-monospace, 'Cascadia Mono', Consolas, monospace;\n\n  /* Form */\n  --radius-sm: 3px;\n  --radius: 4px;\n  --tick: var(--accent-primary);\n  --header-height: 64px;\n  /* Themenfarben für Icons (gedeckt, passend zu den Neutraltönen) */\n  --tone-accent: var(--accent-primary);\n  --tone-sun: #c98a0b;\n  --tone-water: #2f6fae;\n  --tone-moon: #6458a8;\n  --tone-health: #bf4a45;\n  --tone-activity: #3a8a4c;\n  --tone-terrain: #77762f;\n  --tone-chart: #4a6fa5;\n  --tone-air: #2b8a95;\n  --tone-key: #b0631b;\n  --tone-display: #8a4f9e;\n  /* Kräftige Icon-Farben (Linien und Details); die Kacheln bleiben pastell (--tone-*) */\n  --vivid-accent: #08806f;\n  --vivid-sun: #d99a00;\n  --vivid-water: #1d6fc4;\n  --vivid-moon: #5a45c9;\n  --vivid-health: #d6352d;\n  --vivid-activity: #23913f;\n  --vivid-terrain: #6d6b12;\n  --vivid-chart: #34609f;\n  --vivid-air: #0b97a6;\n  --vivid-key: #c75f12;\n  --vivid-display: #9a3db8;\n  /* Abschnitts-Bänder der Produktseite */\n  --band-a: #e6eeeb;\n  --band-b: #e9ecf2;\n  --band-buy: #fbf0e6;\n  /* Neon für alles rund ums Kaufen */\n  --neon-buy: #ff5f00;\n  --neon-buy-glow: rgba(255, 95, 0, 0.45);\n  --on-neon: #ffffff;\n  --band-buy-border: #e3cfa8;\n  --band-c: #eee9f1;\n  --page-max: 86rem;\n\n  color-scheme: light;\n}\n\n.dark {\n  --bg-primary: #0a1214;\n  --bg-secondary: #101b1e;\n  --bg-tertiary: #18272b;\n  --text-primary: #e3ebe9;\n  --text-secondary: #a3b5b4;\n  --text-tertiary: #84999a;\n  --border-primary: #22363a;\n  --border-secondary: #2f474c;\n  --shadow-primary: rgba(0, 0, 0, 0.45);\n  --shadow-secondary: rgba(0, 0, 0, 0.3);\n  --accent-primary: #43c9b6;\n  --accent-secondary: #5fb3d1;\n  --accent-hover: #6bd8c8;\n  --accent-soft: #12302d;\n  --on-accent: #06211d;\n  --brand-deep: #0b3b52;\n  --signal: #ff8a3d;\n  --signal-soft: #33200f;\n  --success: #7bd389;\n  --warning: #f5b84a;\n  --error: #f87171;\n  --tone-accent: var(--accent-primary);\n  --tone-sun: #f2c14e;\n  --tone-water: #6aa8e0;\n  --tone-moon: #a99cf0;\n  --tone-health: #ef8a84;\n  --tone-activity: #7ccf8c;\n  --tone-terrain: #c7c46e;\n  --tone-chart: #8fb0e0;\n  --tone-air: #6fd0da;\n  --tone-key: #f0a35e;\n  --tone-display: #d29be6;\n  --vivid-accent: #4fd8c4;\n  --vivid-sun: #ffcc33;\n  --vivid-water: #5aaeff;\n  --vivid-moon: #a594ff;\n  --vivid-health: #ff7a70;\n  --vivid-activity: #6ee08a;\n  --vivid-terrain: #d6d26a;\n  --vivid-chart: #8db8ff;\n  --vivid-air: #4fe0ee;\n  --vivid-key: #ffa45c;\n  --vivid-display: #e290ff;\n  --band-a: #0e191c;\n  --band-b: #0f1720;\n  --band-buy: #15110e;\n  --neon-buy: #ff7a1a;\n  --neon-buy-glow: rgba(255, 122, 26, 0.55);\n  --on-neon: #1a0a00;\n  --band-buy-border: #4a3d22;\n  --band-c: #15121b;\n  color-scheme: dark;\n}\n\nbody {\n  background-color: var(--bg-primary);\n  color: var(--text-primary);\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n/* Scrollbar */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: var(--bg-primary);\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--border-secondary);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--text-tertiary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
